// extracted by mini-css-extract-plugin
export default {"job-results-container":"EQx6dk","total-items-container":"jkRhas","tooltip-container":"hG046g"};